import { render, staticRenderFns } from "./EditorSection.vue?vue&type=template&id=2330dc1d&scoped=true&"
import script from "./EditorSection.vue?vue&type=script&lang=js&"
export * from "./EditorSection.vue?vue&type=script&lang=js&"
import style0 from "./EditorSection.vue?vue&type=style&index=0&id=2330dc1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2330dc1d",
  null
  
)

export default component.exports